import { BudgetAPI } from "@griffingroupglobal/eslib-api";

const editBudgetTypeHandler = async (props) => {
  const { oldBudgetType, newBudgetType, budgetLastUpdated, budgetId } = props;

  const response = await BudgetAPI.patch(
    budgetId,
    { budgetType: newBudgetType },
    { budgetType: oldBudgetType },
    { date: budgetLastUpdated }
  );

  return response.data;
};

export default editBudgetTypeHandler;
